const drawerSelector = "[data-drawer]";
const openDrawerSelector = "[data-drawer-open]";
const closeDrawerSelector = "[data-drawer-close]";

function drawerTriggers(drawer) {
  return Array.from(document.querySelectorAll(openDrawerSelector)).filter(
    (trigger) => trigger.dataset.drawerOpen === drawer.id,
  );
}

function lockDocument() {
  const root = document.documentElement;
  if (root.dataset.drawerLocked === "true") return;

  root.dataset.drawerLocked = "true";
  root.dataset.drawerHadOverflowHidden = root.classList.contains("overflow-hidden").toString();
  root.dataset.drawerPaddingRight = root.style.paddingRight;

  const scrollBarWidth = window.innerWidth - root.clientWidth;
  root.classList.add("overflow-hidden");
  root.style.paddingRight = `${scrollBarWidth}px`;
}

function unlockDocument() {
  const root = document.documentElement;
  if (root.dataset.drawerLocked !== "true") return;

  if (root.dataset.drawerHadOverflowHidden !== "true") {
    root.classList.remove("overflow-hidden");
  }
  root.style.paddingRight = root.dataset.drawerPaddingRight || "";

  delete root.dataset.drawerLocked;
  delete root.dataset.drawerHadOverflowHidden;
  delete root.dataset.drawerPaddingRight;
}

function closeDrawer(drawer, { restoreFocus = true, updateLock = true } = {}) {
  if (!drawer) return;

  drawer.classList.replace("translate-x-0", "translate-x-full");
  drawer.setAttribute("aria-hidden", "true");
  drawer.inert = true;
  drawerTriggers(drawer).forEach((trigger) => trigger.setAttribute("aria-expanded", "false"));

  if (restoreFocus && drawer.drawerTrigger?.isConnected) {
    drawer.drawerTrigger.focus();
  }
  drawer.drawerTrigger = null;

  if (updateLock && !document.querySelector(`${drawerSelector}[aria-hidden="false"]`)) {
    unlockDocument();
  }
}

function openDrawer(drawer, trigger) {
  if (!drawer) return;

  document.querySelectorAll(`${drawerSelector}[aria-hidden="false"]`).forEach((openDrawer) => {
    if (openDrawer !== drawer) {
      closeDrawer(openDrawer, { restoreFocus: false, updateLock: false });
    }
  });

  drawer.drawerTrigger = trigger;
  drawer.inert = false;
  drawer.setAttribute("aria-hidden", "false");
  drawer.classList.replace("translate-x-full", "translate-x-0");
  drawerTriggers(drawer).forEach((drawerTrigger) => drawerTrigger.setAttribute("aria-expanded", "true"));
  lockDocument();
  drawer.querySelector(closeDrawerSelector)?.focus();
}

export { closeDrawer, openDrawer };

function resetDrawers() {
  document.querySelectorAll(drawerSelector).forEach((drawer) => {
    closeDrawer(drawer, { restoreFocus: false, updateLock: false });
  });
  unlockDocument();
}

document.addEventListener("click", function (event) {
  const trigger = event.target.closest(openDrawerSelector);
  if (trigger) {
    openDrawer(document.getElementById(trigger.dataset.drawerOpen), trigger);
    return;
  }

  const closeButton = event.target.closest(closeDrawerSelector);
  if (closeButton) {
    closeDrawer(closeButton.closest(drawerSelector));
    return;
  }

  const drawerLink = event.target.closest(`${drawerSelector} a`);
  if (drawerLink) {
    closeDrawer(drawerLink.closest(drawerSelector), { restoreFocus: false });
  }
});

document.addEventListener("keydown", function (event) {
  if (event.key !== "Escape") return;

  const openDrawer = document.querySelector(`${drawerSelector}[aria-hidden="false"]`);
  if (openDrawer) closeDrawer(openDrawer);
});

document.addEventListener("turbo:before-render", resetDrawers);
